/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RuleBriefDto } from './RuleBriefDto';
import type { RuleDto } from './RuleDto';

export type RecommendationMonitorDto = {
    createdBy?: string;
    createdDate?: number;
    existingEquivalentRule?: RuleBriefDto;
    explanation?: string;
    id?: string;
    lastModifiedDate?: number;
    modifiedBy?: string;
    params?: RuleDto;
    recommendationSessionId?: string;
    recommendationStatus?: RecommendationMonitorDto.recommendationStatus;
    siffletRule?: RuleBriefDto;
};

export namespace RecommendationMonitorDto {

    export enum recommendationStatus {
        PENDING = 'PENDING',
        ACCEPTED = 'ACCEPTED',
        REFUSED = 'REFUSED',
    }


}
